export default __webpack_public_path__ + "static/media/5de67fd7d7dc4b705c7209d6165e737a.svg";